
define('text!templates/modules/questionnaire/modal/questionnaire-responses-download-modal.html',[],function () { return '<div class="logo"><img class="logo-image" src={{logoUrl}} onerror="this.src=\'assets/images/yourlogo.png\';" /></div>\n<hr />\n<p>\n<strong>{{ title }}</strong> <br><br>\n{{ userName }} <br><br>\n{{ dateCompleted }}</p>\n<hr />\n\n<div class="questions-list"></div>\n';});

